import type { Graphics as PixiGraphics } from "pixi.js";

/** Same green as available desks. */
export const BLOCKED_MARK_GREEN = 0x28b869;
/** Red prohibition ring and diagonal slash. */
export const BLOCKED_MARK_SLASH = 0xff0000;

/**
 * Green status disc with a red prohibition ring and diagonal slash
 * (top-left → bottom-right). Shared by place status circles and
 * conference-zone center marks.
 */
export function drawBlockedProhibitionMark(
  g: PixiGraphics,
  radius: number,
  lineWidth: number
): void {
  g.clear();
  g.lineStyle(lineWidth, 0xffffff);
  g.beginFill(BLOCKED_MARK_GREEN, 1);
  g.drawCircle(0, 0, radius);
  g.endFill();

  const stroke = Math.max(lineWidth * 1.4, radius * 0.12);
  const ringRadius = radius * 0.85;
  g.lineStyle(stroke, BLOCKED_MARK_SLASH);
  g.drawCircle(0, 0, ringRadius);

  const inset = ringRadius * 0.65;
  g.moveTo(-inset, -inset);
  g.lineTo(inset, inset);
}
